var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.1 44",
    style: {
      enableBackground: "new 0 0 31.1 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.7,15.4c0.1-0.6-0.1-1.2-0.5-1.6c-0.4-0.4-0.9-0.6-1.4-0.6c-1.1,0-2,0.9-2,2v4.9c0,6.1-5,11-11.1,11c-6.1,0-11-5-11-11 v-4.9c0-1.1-0.9-2-2-2c-1.1,0-2.2,1-2.2,2.1v4.9c0,7.4,5.4,13.8,12.7,15v5.9c0,1.1,0.9,2,2,2s2.1-0.9,2.1-2v-5.8 c7.6-0.8,13.5-7.4,13.5-15L30.7,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.7,29.1c5,0,9.1-4.1,9.1-9.1v-8.7c0-5-4.1-9.1-9.1-9.1s-9.1,4.1-9.1,9.1V20C6.5,25,10.6,29.1,15.7,29.1z M21.1,17.5V20 c0,3-2.4,5.5-5.5,5.5c-3,0-5.4-2.5-5.4-5.5v-2.5H21.1z M10.2,11.3c0-3,2.4-5.5,5.4-5.5c3,0,5.5,2.5,5.5,5.5v2.5H10.2V11.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.a0657be5d325d8c4985e992913e183af.svg";
export { ForwardRef as ReactComponent };